import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "style", "children", "dense", "fullWidth", "spacing", "pushLastChildToEnd", "align", "justify", "wrap", "onClick"];
import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cn from 'classnames';
var spacer = {
  sm: 7,
  md: 20,
  lg: 45
};
var useStyles = createUseStyles({
  row: {
    '& > * ': {
      marginRight: function marginRight(_ref) {
        var spacing = _ref.spacing;
        return spacer[spacing];
      }
    },
    '& > *:last-child': {
      marginRight: 0,
      marginLeft: function marginLeft(_ref2) {
        var pushLastChildToEnd = _ref2.pushLastChildToEnd;
        return pushLastChildToEnd ? 'auto' : 'initial';
      }
    }
  }
});
var Row = /*#__PURE__*/React.forwardRef(function Row(_ref3, ref) {
  var className = _ref3.className,
      style = _ref3.style,
      children = _ref3.children,
      dense = _ref3.dense,
      fullWidth = _ref3.fullWidth,
      spacing = _ref3.spacing,
      pushLastChildToEnd = _ref3.pushLastChildToEnd,
      align = _ref3.align,
      justify = _ref3.justify,
      wrap = _ref3.wrap,
      onClick = _ref3.onClick,
      props = _objectWithoutProperties(_ref3, _excluded);

  var classes = useStyles({
    spacing: spacing,
    pushLastChildToEnd: pushLastChildToEnd
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref,
    role: "presentation",
    onClick: onClick,
    className: cn({
      clickable: onClick
    }, 'd-flex', _defineProperty({}, "row-wrapper ".concat(classes.row), !dense), {
      'w-fill': fullWidth
    }, _defineProperty({}, "align-items-".concat(align), align), _defineProperty({}, "justify-content-".concat(justify), justify), {
      'flex-row-wrap': wrap
    }, className),
    style: style
  }), children);
});
Row.defaultProps = {
  className: '',
  spacing: 'md',
  style: {},
  children: null,
  onClick: null,
  dense: false,
  fullWidth: false,
  align: 'inherit',
  justify: 'inherit',
  wrap: false,
  pushLastChildToEnd: false
};
Row.propTypes = {
  /** Additional classes for row */
  className: PropTypes.string,

  /** Additional classes for row */
  align: PropTypes.string,

  /** Additional classes for row */
  justify: PropTypes.string,

  /** Additional styles for row */
  style: PropTypes.shape(),

  /** Children for row wrapper */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),

  /** Boolean whether or not we are in dense (no margins) mode */
  dense: PropTypes.bool,

  /** Boolean whether or not we are in full width mode */
  fullWidth: PropTypes.bool,

  /** Amount of spacing between child elements -
   *  sm - 7 md - 20. By default in forms 20 is enforced.
   *  generally:
   *  sm - used for spacing inner components
   *  md - used for default spacing structures
   *  lg - used for spacing larger structures
   *  md is set by default
   */
  spacing: PropTypes.oneOf(['sm', 'md', 'lg']),

  /** Set row as wrap to fit content */
  wrap: PropTypes.bool,

  /** Push the last row child to the end of the row */
  pushLastChildToEnd: PropTypes.bool,

  /** handle click event for Col */
  onClick: PropTypes.func
}; // Hack for withInfo plugin

Row.displayName = 'Row';
export default Row;